/**
 * URL-hash keys for the sorting feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#delete/5`).
 */
export const SORTING_HASH = {
  /** `#refuse` — move-to-repair dialog for the selected container (detail page). */
  refuse: 'refuse',
  /** `#scan` — camera QR scan dialog (listing). */
  scan: 'scan',
  /** `#delete/<id>` — single-session delete confirmation (listing). */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type SortingHashKey = (typeof SORTING_HASH)[keyof typeof SORTING_HASH];
